.wrapper {
  display: inline-flex;
  align-items: center;
  font-size: 18px;
  letter-spacing: 1px;
}

.clinic {
  text-transform: uppercase;
}

.dash {
  margin: 0 0.3rem;
}

.code {
  padding: 4px 12px;
  background-color: var(--gray-light);
  border-radius: 24px;
}
